import React, { Component } from "react";
import { Modal } from "antd";

import server from "../../axios/server";

class BarrierImage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      feeRules: [],
    };
  }
  getPhotoUrl(url) {
    if (url.indexOf("http") === 0) {
      var idx = url.indexOf(":9012/");
      var subUrl = url.substring(idx + 6);
      return server.barrier_img_url + subUrl;
    } else {
      if (url.indexOf("/barrier_img") === 0) {
        url = "/opt/tc/images" + url;
      }
      return (
        server.mallServerUrl +
        "/common/image?imagePath=" +
        encodeURIComponent(url)
      );
    }
  }
  render() {
    const { visible, onCancel, editData } = this.props;
    var photoUrl = editData.photoUrl;
    if (photoUrl) {
      return (
        <Modal
          visible={visible}
          title="道闸照片"
          maskClosable={true}
          onCancel={onCancel}
          footer={null}
        >
          <img
            alt={this.getPhotoUrl(photoUrl)}
            src={this.getPhotoUrl(photoUrl)}
            style={{ width: "100%" }}
          />
        </Modal>
      );
    } else {
      return <div></div>;
    }
  }
}

export default BarrierImage;
